import { Checklist } from '@mui/icons-material';
import { CREATE, GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE, UPDATE } from 'react-admin';

import CriteriaList from './List';
import CriteriaShow from './Show';
import CriterionCreate from './Create';
import CriterionEdit from './Edit';
import { ResourceDefinition, ResourceSections } from 'src/types';
import { arrayToPostgresLiteral } from 'src/utils/hasura';

export const CriteriaResource: ResourceDefinition = {
  name: 'criteria',
  section: ResourceSections.PORTAL,
  icon: Checklist,
  options: { label: 'Risk Signals' },

  list: CriteriaList,
  show: CriteriaShow,
  create: CriterionCreate,
  edit: CriterionEdit,

  permissions: {
    list: ['criteria:read'],
    create: ['criteria:edit'],
    edit: ['criteria:edit'],
  },

  extension: {
    operations: {
      [GET_LIST]: {
        operationName: 'portal_criteria',
      },
      [GET_ONE]: {
        operationName: 'portal_criteria',
      },
      [GET_MANY]: {
        operationName: 'portal_criteria',
      },
      [GET_MANY_REFERENCE]: {
        operationName: 'portal_criteria',
      },
    },

    transformVariables(ctx) {
      if ([CREATE, UPDATE].includes(ctx.operation.type)) {
        const params = ctx.operation.type === CREATE ? ctx.variables.objects : ctx.variables._set;
        const { search_columns, api_field_paths } = params;
        if (Array.isArray(search_columns)) {
          params.search_columns = search_columns.length > 0 ? arrayToPostgresLiteral(search_columns) : null;
        }
        if (Array.isArray(api_field_paths)) {
          params.api_field_paths = api_field_paths.length > 0 ? arrayToPostgresLiteral(api_field_paths) : null;
        }
      }

      return ctx;
    },
  },
};
